module.exports = __webpack_public_path__ + "img/grasse_21.8a9b6a31.png";